import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

export async function generateInstitutionInvite(payload = {}) {
  const callable = getFunctions().httpsCallable("generateInstitutionInvite");
  const result = await callable(payload);
  return result.data;
}

export async function generateHierarchyInvite(payload) {
  const callable = getFunctions().httpsCallable("generateHierarchyInvite");
  const result = await callable(payload);
  return result.data;
}

export async function claimHierarchyInvite(inviteCode) {
  const callable = getFunctions().httpsCallable("claimHierarchyInvite");
  const result = await callable({ inviteCode });
  return result.data;
}

export async function revokeHierarchyInvite(inviteCode) {
  const callable = getFunctions().httpsCallable("revokeHierarchyInvite");
  const result = await callable({ inviteCode });
  return result.data;
}

export async function getHierarchyInvitePreview(inviteCode) {
  const callable = getFunctions().httpsCallable("getHierarchyInvitePreview");
  const result = await callable({ inviteCode });
  return result.data;
}

export async function listSentHierarchyInvites(uid) {
  const { db } = await import("services/firebase");
  const snap = await db
    .collection("hierarchyInvites")
    .where("invitedBy", "==", uid)
    .orderBy("invitedAt", "desc")
    .limit(50)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}
